export enum U2000_ESignatureNavigationStepsEnum {
    chooseSendingMethod,
    verifyCode,
}
